module.exports = __webpack_public_path__ + "img/experience.ca8812c6.svg";